// extracted by mini-css-extract-plugin
module.exports = {"ErrorContainer":"ErrorMessage_ErrorContainer__jba0T","ErrorTitle":"ErrorMessage_ErrorTitle__KfKQT","ErrorMessage":"ErrorMessage_ErrorMessage__6ZeUU"};